import { Dtos } from "@inrev/common";
import { decisioningFactorsQueryKey } from "../decisioning.keys";
import { type Factor } from "../types";
import { useCreateCatalogItem } from "./catalog";

export const useCreateDecisioningFactor = () => {
	const mutation = useCreateCatalogItem<Factor, Dtos.Decisioning.Factor.Create.Request>({
		path: "/v2/admin/decisioning/factors",
		queryKey: decisioningFactorsQueryKey(),
		responseSchema: Dtos.Decisioning.Factor.Get.Response.schema,
	});

	return {
		createFactorAsync: mutation.mutateAsync,
		createFactorLoading: mutation.isPending,
	};
};
